// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3U-ky","primary":"button_primary__nfzye","secondary":"button_secondary__2k3bX","large":"button_large__ugGYX","medium":"button_medium__1MUEF"};